import { SimpleInput, SimpleInputProps, SimpleSelect } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';

import { useZodFormContext } from '../../../hooks/useZodForm.ts';
import { schObjectiveCharacteristics } from '../schObjectiveCharacteristics.ts';

type AreaInputProps = Pick<
  SimpleInputProps,
  'onChange' | 'onBlur' | 'name' | 'label' | 'required' | 'value'
> & {
  unitControlName: 'area.unit';
};

export const AreaInputWithUnit = forwardRef<HTMLInputElement, AreaInputProps>((props, ref) => {
  const { unitControlName, ...areaControlProps } = props;

  const { control } = useZodFormContext<typeof schObjectiveCharacteristics>();

  return (
    <SimpleInput
      ref={ref}
      size="sm"
      type="number"
      rightAddon={
        <Controller
          name={unitControlName}
          control={control}
          render={({ field }) => (
            <SimpleSelect size="sm" {...field}>
              <option value="sqft">sf</option>
              <option value="acre">ac</option>
            </SimpleSelect>
          )}
        />
      }
      useSeparator
      {...areaControlProps}
    />
  );
});
